import React from 'react';
import { translate } from 'react-translate';
import Textblock from '../Components/Textblock';

const MassInfo = (props) => {
  return (
    <div className="mass-info">
        <h2 className="mass-info-heading">Bohoslužby</h2>
        <p className="mass-info-subtitle">Pravidelný program – výjimky vyhrazeny, uvedeny v ohláškách na daný týden.</p>
        <div className="mass-info-content">
            <Textblock codename="bohosluzby" language={props.language} />
        </div>
    </div>
  )
}

export default translate("MassInfo")(MassInfo);